import { SvgIcon, SvgIconProps } from '@mui/material';

export const Stations = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 22 22" {...props}>
    <path
      d="M16 13C19.2927 13.6904 21 15.1241 21 16.7807C21 19.111 16.5228 21 11 21C5.47715 21 1 19.111 1 16.7807C1 15.1241 2.70729 13.6904 6 13M11 11C13.7614 11 16 8.76142 16 6C16 3.23858 13.7614 1 11 1C8.23858 1 6 3.23858 6 6C6 8.76142 8.23858 11 11 11ZM11 11V17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
